import axios from 'axios';
import {
    AddPackageMemberCommand,
    AdminPackageDto,
    PackageDetailDto,
    PackageHistoryDto,
    PackageMemberDto,
    PackageRoleDto,
    RemovePackageMemberCommand,
    RestorePackageVersionCommand,
    UpdatePackageCommand,
    UserPackagePermissions,
} from './models/PackageDto';

export const getAllPackages = async (): Promise<AdminPackageDto[]> => {
    const { data: packages } = await axios.get<AdminPackageDto[]>(
        `${window.configuration.apiUrl}api/packages`,
    );

    return packages;
};

export const getPackageById = async (id: string): Promise<PackageDetailDto> => {
    const { data: packageDetail } = await axios.get<PackageDetailDto>(
        `${window.configuration.apiUrl}api/packages/${id}`,
    );

    return packageDetail;
};

export const updatePackage = async (command: UpdatePackageCommand): Promise<boolean> => {
    await axios.put(`${window.configuration.apiUrl}api/packages`, command);

    return true;
};

export const getPackageHistory = async (packageId: string): Promise<PackageHistoryDto[]> => {
    const { data: history } = await axios.get<PackageHistoryDto[]>(
        `${window.configuration.apiUrl}api/packages/${packageId}/history`,
    );

    return history;
};

export const restorePackageVersion = async (
    command: RestorePackageVersionCommand,
): Promise<boolean> => {
    await axios.post(`${window.configuration.apiUrl}api/packages/restore`, command);

    return true;
};

export const getPackageUserRoles = async (packageId: string): Promise<UserPackagePermissions> => {
    const { data: permissions } = await axios.get<UserPackagePermissions>(
        `${window.configuration.apiUrl}api/packages/${packageId}/user-roles`,
    );

    return permissions;
};

export const getMyPackageRoles = async (): Promise<PackageRoleDto[]> => {
    const { data: roles } = await axios.get<PackageRoleDto[]>(
        `${window.configuration.apiUrl}api/Packages/roles/me`,
    );

    return roles;
};

export const getPackageMembers = async (packageId: string): Promise<PackageMemberDto[]> => {
    const { data: members } = await axios.get<PackageMemberDto[]>(
        `${window.configuration.apiUrl}api/packages/${packageId}/members`,
    );

    return members;
};

export const addPackageMember = async (command: AddPackageMemberCommand): Promise<boolean> => {
    await axios.post(
        `${window.configuration.apiUrl}api/packages/${command.packageId}/members`,
        command,
    );

    return true;
};

export const removePackageMember = async (
    command: RemovePackageMemberCommand,
): Promise<boolean> => {
    await axios.delete(`${window.configuration.apiUrl}api/packages/${command.packageId}/members`, {
        data: command,
    });

    return true;
};

export const clonePackage = async (packageId: string): Promise<string> => {
    const { data: newPackageId } = await axios.post<string>(
        `${window.configuration.apiUrl}api/packages/${packageId}/clone`,
    );

    return newPackageId;
};
